import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import classNames from "classnames";
import isEmpty from "lodash/isEmpty";
import { ErrorText } from "../../../components";
import BootstrapSwitchButton from "bootstrap-switch-button-react";

const TYPES = [
  { name: "Tile", value: "tile" },
  { name: "Non Tile", value: "nonTile" },
];

const PRICE_TYPES = [
  { name: "Per piece / Per box", value: "Per piece / Per box" },
  { name: "Per Sqft", value: "Per Sqft" },
];

const QUANTITY_TYPES = [
  { name: "Per Sqft", value: "Per Sqft" },
  { name: "Per Box", value: "Per Box" },
  { name: "Per Litre", value: "Per Litre" },
  { name: "Per Bag", value: "Per Bag" },
  { name: "Per KG", value: "Per KG" },
  { name: "Per piece", value: "Per piece" },
];

export default class AddProductModal extends Component {
  constructor() {
    super();
    this.state = this.initState();
  }

  initState = () => ({
    form: {
      title: "",
      idealFor: "",
      thickness: "",
      sellingPrice: "",
      mrp: "",
      price: "",
      closingStockCount: "",
      productType: "",
      priceType: "",
      quantityType: "",
      discountPrice: "",
      inclusiveTaxes: false,
      quality: "",
      materialType: "",
      finish: "",
      brand: "",
      weightPerPiece: "",
      size: "",
      ratePerSqft: "",
      coverArea: "",
      parentCategoryId: "",
      parentSubCategoryId: "",
      isTileOrGranite: 0,
    },
    errors: {},
    localCategoryId: "", // Local state for category
    localSubCategoryId: "", // Local state for subcategory
  });

  componentDidUpdate(prevProps) {
    if (prevProps.categories !== this.props.categories) {
      this.setState(this.initState());
    }
  }

  onSave = () => {
    const { onAddProducts } = this.props;
    const { form, localCategoryId, localSubCategoryId } = this.state;

    // Update form with local category and subcategory before saving
    const updatedForm = {
      ...form,
      parentCategoryId: localCategoryId,
      parentSubCategoryId: localSubCategoryId,
    };

    onAddProducts(updatedForm);
    this.setState(this.initState());
  };

  validateForm = () => {
    const { form } = this.state;
    const errors = {};
    const requiredFields = [
      "title",
      "productType",
      "closingStockCount",
      "priceType",
      "quantityType",
      "discountPrice",
      "idealFor",
      "quality",
      "materialType",
      "finish",
      "brand",
      "weightPerPiece",
      "size",
      "thickness",
      "sellingPrice",
      "mrp",
      "price",
      "ratePerSqft",
      "coverArea",
      "parentCategoryId",
      "parentSubCategoryId",
    ];

    requiredFields.forEach((field) => {
      if (!form[field]) errors[field] = "Required";
    });

    this.setState({ errors });
    return isEmpty(errors);
  };

  onInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((state) => ({
      form: {
        ...state.form,
        [name]: value,
      },
      errors: {
        ...state.errors,
        [name]: "",
      },
    }));
  };

  onCategoryChange = (e) => {
    const selectedCategoryId = e.target.value;
    this.setState({
      localCategoryId: selectedCategoryId,
      localSubCategoryId: "", // Reset subcategory when category changes
    });
  };

  onSubCategoryChange = (e) => {
    const selectedSubCategoryId = e.target.value;
    this.setState({
      localSubCategoryId: selectedSubCategoryId,
    });
  };

  onStatusChange = (value) => {
    this.setState((state) => ({
      form: {
        ...state.form,
        inclusiveTaxes: value,
      },
    }));
  };

  onClose = () => {
    this.setState(this.initState());
    this.props.onHide();
  };

  renderSelectField = (label, name, options, form, errors, onChange) => (
    <div className="col-md-6 mb-2">
      <div className="form-group">
        <label className={classNames({ "text-danger": errors[name] })}>
          {label}
        </label>
        <select
          name={name}
          value={form[name]}
          onChange={onChange}
          className={classNames("form-control", { "is-invalid": errors[name] })}
        >
          <option value="" disabled>
            Select
          </option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.name}
            </option>
          ))}
        </select>
        <ErrorText error={errors[name]} />
      </div>
    </div>
  );

  renderTextField = (
    label,
    name,
    placeholder,
    form,
    errors,
    maxLength = null
  ) => (
    <div className="col-md-6 mb-2">
      <div className="form-group">
        <label className={classNames({ "text-danger": errors[name] })}>
          {label}
        </label>
        <input
          type="text"
          name={name}
          value={form[name]}
          onChange={this.onInputChange}
          placeholder={placeholder}
          maxLength={maxLength}
          className={classNames("form-control", { "is-invalid": errors[name] })}
        />
        <ErrorText error={errors[name]} />
      </div>
    </div>
  );

  render() {
    const { form, errors, localCategoryId, localSubCategoryId } = this.state;
    const { show, categories, subCategories } = this.props;

    return (
      <Modal show={show} onHide={this.onClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Product</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            {this.renderSelectField(
              "Product Type",
              "productType",
              TYPES,
              form,
              errors,
              this.onInputChange
            )}
            {this.renderTextField(
              "Product Name",
              "title",
              "Enter product name",
              form,
              errors,
              20
            )}
            {/* Category Field */}
            <div className="col-md-6 mb-2">
              <div className="form-group">
                <label>Category</label>
                <select
                  className="form-control"
                  value={localCategoryId}
                  onChange={this.onCategoryChange}
                >
                  <option value="" disabled>
                    Select
                  </option>
                  {categories.map((category) => (
                    <option key={category.id} value={category.id}>
                      {category.displayName}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {/* Sub Category Field */}
            <div className="col-md-6 mb-2">
              <div className="form-group">
                <label>Subcategory</label>
                <select
                  className="form-control"
                  value={localSubCategoryId}
                  onChange={this.onSubCategoryChange}
                >
                  <option value="" disabled>
                    Select
                  </option>
                  {subCategories.map((subCategory) => (
                    <option key={subCategory.id} value={subCategory.id}>
                      {subCategory.displayName}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {this.renderSelectField(
              "Price Type",
              "priceType",
              PRICE_TYPES,
              form,
              errors,
              this.onInputChange
            )}
            {this.renderSelectField(
              "Quantity Type",
              "quantityType",
              QUANTITY_TYPES,
              form,
              errors,
              this.onInputChange
            )}
            {this.renderTextField(
              "Discount Price",
              "discountPrice",
              "Enter discount price",
              form,
              errors
            )}
            {this.renderTextField(
              "Ideal For",
              "idealFor",
              "Enter ideal for",
              form,
              errors
            )}
            {this.renderTextField(
              "Quality",
              "quality",
              "Enter quality",
              form,
              errors
            )}
            {this.renderTextField(
              "Material Type",
              "materialType",
              "Enter material type",
              form,
              errors
            )}
            {this.renderTextField(
              "Finish",
              "finish",
              "Enter finish",
              form,
              errors
            )}
            {this.renderTextField(
              "Brand",
              "brand",
              "Enter brand",
              form,
              errors
            )}
            {this.renderTextField(
              "Weight Per Piece",
              "weightPerPiece",
              "Enter weight per piece",
              form,
              errors
            )}
            {this.renderTextField(
              "Selling Price",
              "sellingPrice",
              "Enter selling price",
              form,
              errors
            )}
            {this.renderTextField(
              "Rate Per Sqft",
              "ratePerSqft",
              "Enter rate per sqft",
              form,
              errors
            )}
            {this.renderTextField(
              "Cover Area",
              "coverArea",
              "Enter cover area",
              form,
              errors
            )}
            {this.renderTextField(
              "Price",
              "price",
              "Enter price",
              form,
              errors
            )}
            {this.renderTextField(
              "Closing Stock Count",
              "closingStockCount",
              "Enter closing stock count",
              form,
              errors
            )}
            {this.renderTextField(
              "Thickness",
              "thickness",
              "Enter thickness",
              form,
              errors
            )}
            {this.renderTextField("Size", "size", "Enter size", form, errors)}
            {this.renderTextField("MRP", "mrp", "Enter MRP", form, errors)}
            <div className="col-md-6 mb-2">
              <label className="mb-2">Inclusive Taxes</label>
              <BootstrapSwitchButton
                onlabel="Yes"
                offlabel="No"
                checked={form.inclusiveTaxes}
                size="xs"
                width={100}
                onstyle="success"
                offstyle="danger"
                onChange={this.onStatusChange}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary" onClick={this.onSave}>
            Add Product
          </button>
          <button className="btn btn-secondary" onClick={this.onClose}>
            Cancel
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
